module.exports = __webpack_public_path__ + "static/media/WiBox.6748753f.jpg";